import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    empty: 'No giveaways yet',
    winnersOne: '{{count}} winner',
    winnersFew: '{{count}} winners',
    winnersMany: '{{count}} winners',
  },
  ru: {
    empty: 'Раздач ещё не было',
    winnersOne: '{{count}} победитель',
    winnersFew: '{{count}} победителя',
    winnersMany: '{{count}} победителей',
  },
  uz: {
    empty: 'Hali ulashish boʻlmagan',
    winnersOne: '{{count}} gʻolib',
    winnersFew: '{{count}} gʻolib',
    winnersMany: '{{count}} gʻolib',
  },
  fa: {
    empty: 'هنوز پخشی نبوده',
    winnersOne: '{{count}} برنده',
    winnersFew: '{{count}} برنده',
    winnersMany: '{{count}} برنده',
  },
  pt: {
    empty: 'Ainda não houve sorteios',
    winnersOne: '{{count}} vencedor',
    winnersFew: '{{count}} vencedores',
    winnersMany: '{{count}} vencedores',
  },
  tr: {
    empty: 'Henüz çekiliş olmadı',
    winnersOne: '{{count}} kazanan',
    winnersFew: '{{count}} kazanan',
    winnersMany: '{{count}} kazanan',
  },
  uk: {
    empty: 'Роздач ще не було',
    winnersOne: '{{count}} переможець',
    winnersFew: '{{count}} переможці',
    winnersMany: '{{count}} переможців',
  },
  de: {
    empty: 'Noch keine Giveaways',
    winnersOne: '{{count}} Gewinner',
    winnersFew: '{{count}} Gewinner',
    winnersMany: '{{count}} Gewinner',
  },
  es: {
    empty: 'Aún no hay giveaways',
    winnersOne: '{{count}} ganador',
    winnersFew: '{{count}} ganadores',
    winnersMany: '{{count}} ganadores',
  },
  pl: {
    empty: 'Nie było jeszcze rozdań',
    winnersOne: '{{count}} zwycięzca',
    winnersFew: '{{count}} zwycięzców',
    winnersMany: '{{count}} zwycięzców',
  },
});
